import { render, staticRenderFns } from "./his.vue?vue&type=template&id=998273a8&scoped=true"
import script from "./his.vue?vue&type=script&lang=js"
export * from "./his.vue?vue&type=script&lang=js"
import style0 from "./his.vue?vue&type=style&index=0&id=998273a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998273a8",
  null
  
)

export default component.exports